import { FunctionComponent } from 'react';
import { DirectDeposit } from 'payroll/direct-deposit.react';

const TablesDirectDepositElement: FunctionComponent<React.PropsWithChildren<DynamicForm.CustomElement>> = ({context}) => {

	const {
		formOptions: {isNHPPacket},
	} = context;

	return (
		<>
			<DirectDeposit
				employeeId={ 0 }
				isDisabled={ isNHPPacket }
				isNewEmployeeForm={ true }
			/>
		</>
	);
};

export default TablesDirectDepositElement;
